import React from 'react';
const logoSize = {
  width: '47px',
  height: '47px',
  border: '0px solid white',
  borderRadius: '0px'
};

function Logo(props) {
  return (
    <img style={logoSize} alt="Logo" src="/static/logo-S.png" {...props} />
  );
}

export default Logo;
